import "./style.scss"
const Index = ({ setDeleteRoleModal, selectedRole, setSelectedRole, onDeleteRole = () => { } }) => {

    return (
        <div className="small-modal-wrapper">
            <div className="delete-modal-content">
                <div style={{position:'relative', justifyContent:'center', display:'flex', width:'100%'}}>
                <i className='fal fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '0px', top: '0px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
                    setDeleteRoleModal(false)
                    setSelectedRole(null)
                }}></i>
                <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#DC1E00', color: 'var(--white)' }}>
                    <i class="fal fa-trash-alt"></i>
                </span>
                </div>
                <h2>Are you sure?</h2>
                <p>You are about to delete this <strong>{selectedRole?.name || '-'}</strong> role.</p>
                <button className='btn' onClick={onDeleteRole}>Delete Role</button>
                <button className='btn transparent' onClick={() => {
                    setDeleteRoleModal(false)
                    setSelectedRole(null)
                }}>Cancel</button>
            </div>
        </div>
    )
}

export default Index